import { keccak256 } from 'js-sha3';

/**
 * Convert a hex Ethereum address to its EIP-55 mixed-case checksum form.
 * Returns the original string unchanged if it is not a valid 40-hex address.
 *
 * @see https://eips.ethereum.org/EIPS/eip-55
 */
export function toChecksumAddress(address: string): string {
  const stripped = address.replace(/^0x/i, '').toLowerCase();
  if (!/^[0-9a-f]{40}$/.test(stripped)) {
    return address;
  }

  const hash = keccak256(stripped);
  let checksummed = '0x';

  for (let i = 0; i < 40; i++) {
    const hashNibble = Number.parseInt(hash[i], 16);
    checksummed += hashNibble >= 8 ? stripped[i].toUpperCase() : stripped[i];
  }

  return checksummed;
}

/**
 * Check whether a string looks like a raw Ethereum address (0x + 40 hex chars).
 * Does not validate checksum — just checks format.
 */
export function isEthereumAddress(value: string): boolean {
  return /^0x[0-9a-fA-F]{40}$/i.test(value);
}
